<div>
  <button
    class="flex items-center cursor-pointer bg-transparent border-none hover:bg-gray-95 rounded gap-2"
    (click)="toggleExpanded()"
  >
    <div class="flex items-center gap-2">
      <lds-icon [name]="Icon.CLOCK" />
      <span class="text-body-2-desktop font-medium">{{ 'openingHours' | translate }}</span>
    </div>
    <lds-icon [name]="isExpanded() ? Icon.CHEVRON_UP : Icon.CHEVRON_DOWN" />
  </button>

  @if (isExpanded()) {
    <div class="mt-2 pl-2">
      @for (day of daysData(); track day.key) {
        <div class="flex justify-between py-2 px-3 rounded" [class.current-day]="day.isCurrentDay">
          <span class="text-body-2-desktop text-gray-40 capitalize">{{ day.key | translate }}</span>
          @if (day.isOpen) {
            <span class="text-body-2-desktop text-gray-10">{{ day.hours }}</span>
          } @else {
            <span class="text-body-2-desktop text-gray-60">{{ 'closed' | translate }}</span>
          }
        </div>
      }
    </div>
  }
</div>
